module.exports = __webpack_public_path__ + "static/media/FSDH-COMMITMENT-TO-COMPLIANCE.-2ocx.3431fb71.pdf";